module.exports = __webpack_public_path__ + "img/strava.8c734c1c.svg";